/**
 * 로딩바 모듈
 * @module shared/components/LoadingBar
 * @author Lian
 */
import loadingGif from '@/assets/common/image/loading-circle.gif';
import { useLoading } from '@/shared/components/LoadingBarContext.tsx';
import { useCallback, useEffect, useState } from 'react';
import { registerController, unregisterController } from '../utils/LoadingBarService.ts';

/**
 * 전역 로딩바 컴포넌트 생성
 * @author Lian
 */
export const GlobalLoadingBar = () => {
  const { isLoading } = useLoading();

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full z-999 flex justify-center items-center ${
        isLoading ? 'opacity-75' : 'opacity-0 pointer-events-none'
      } bg-background`}
    >
      <img src={loadingGif} />
    </div>
  );
};

/**
 * 로딩바 Interface
 */
interface LoadingBarInterface {
  /**
   * 로딩바 id
   */
  id: string;
}
/**
 * 로딩바 컴포넌트 생성
 * @author Lian
 */
export const LoadingBar: React.FC<LoadingBarInterface> = ({ id }) => {
  const [visible, setVisible] = useState(false);

  const show = useCallback(() => setVisible(true), []);
  const hide = useCallback(() => setVisible(false), []);

  useEffect(() => {
    registerController(id, { show, hide });
    return () => unregisterController(id);
  }, [id, show, hide]);

  return (
    <div
      className={`absolute top-0 left-0 w-full h-full z-999 flex justify-center items-center ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      } bg-background`}
    >
      <img src={loadingGif} />
    </div>
  );
};
